import type { BlogEntry } from 'BlogEntries'
import { FC } from 'react'
import {
  BlogList,
  Container,
  Section,
} from 'atoms'
import {
  ContactCard,
} from 'organisms'

interface BlogAllProps {
  blogEntries: BlogEntry[];
}

const BlogAll: FC<BlogAllProps> = ({
  blogEntries,
}) => (
  <>
    <Section background="rose">
      <Container>
        <h1>
            Blog
        </h1>
        <h2 className="text-center">
            Cordelia Schmidt &amp; Gastautoren
        </h2>
      </Container>
    </Section>
    <Section>
      <Container>
        <BlogList blogEntries={blogEntries} />
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
  </>
)

export default BlogAll
